import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedOregonActivitySpace = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add an activity space"
    okText="ADD AN ACTIVITY SPACE"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      abel="Choose an activity space:"
      queryVariables={{ typeId: FILTER_TYPE.ACTIVITY_SPACE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Activity space is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedOregonActivitySpace.Item = Item;

export default RelatedOregonActivitySpace;
